import Vue from 'vue';
import {
    Table,
    TableColumn,
    Input,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Button,
    DatePicker,
    Checkbox,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import eventBus from "../../../util/eventBus"
import App from "./views/app.vue"


(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }
 
    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----++init', props)
            let containtBoxID = "containtBoxID" + (new Date().getTime())
            new Promise((resolve, reject) => {
                setHtml(this.model, resolve, containtBoxID)
            }).then(() => {
                let height = document.getElementById(containtBoxID).parentElement.offsetHeight - 151
                eventBus.pub(this.model, 'initTableList', {
                    data: props.data,
                    height
                })
                // console.log(this.model.myvue.$children[0].tableData);
            })
        },
        update: function (props) {
            console.log('-----update', props)
            if (props.data.flag === "selectPlan") {
                console.log(this.model.myvue.$children[0].tableData);
                this.model.myvue.$children[0].mateTableData = props.data.data
            }
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, resolve, containtBoxID) => {
        const { invoke, dom } = model

        KDApi.loadFile('./css/index.css', model, () => {

            Vue.use(Table)
            Vue.use(TableColumn)
            Vue.use(Input)
            Vue.use(Dropdown);
            Vue.use(DropdownMenu)
            Vue.use(DropdownItem)
            Vue.use(Button)
            Vue.use(DatePicker)
            Vue.use(Checkbox)

            model.myvue = new Vue({
                el: model.dom,
                template: '<App />',
                components: {
                    App
                },
                data: {
                    model,
                    KDApi
                },
                provide: function () {
                    return {
                        containtBoxID,
                        model,
                        KDApi,
                        myInvoke: this.invoke
                    }
                },
                mounted() {
                    resolve()
                },
                destoryed() {
                    console.log('Vue destory')
                },
                methods: {
                    invoke: function (eventName, args) {
                        invoke(eventName, args)
                    }
                }
            })

        })
    }

    // 注册自定义组件
    KDApi.register('toogleTable', MyComponent, {
        isMulLang: true
    })
})(window.KDApi)
